import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "valueInput"]
  static values = { url: String }

  connect() {
    this.timeout = null
    document.addEventListener("click", this._handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._handleClickOutside)
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this._hideResults()
      if (this.hasValueInputTarget) this.valueInputTarget.value = ""
      return
    }

    this.timeout = setTimeout(() => {
      this._fetchRegions(query)
    }, 250)
  }

  select(event) {
    event.preventDefault()
    this._selecting = true
    const region = JSON.parse(event.currentTarget.dataset.region)
    this.inputTarget.value = region.name
    if (this.hasValueInputTarget) {
      this.valueInputTarget.value = region.value
      this.valueInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this._hideResults()
    this._selecting = false
  }

  onInput() {
    if (!this._selecting && this.hasValueInputTarget) {
      this.valueInputTarget.value = ""
    }
  }

  async _fetchRegions(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Server error")

      const regions = await response.json()
      this._renderResults(regions)
    } catch (error) {
      console.error("Error fetching regions:", error)
      this._hideResults()
    }
  }

  _renderResults(regions) {
    if (regions.length === 0) {
      this._hideResults()
      return
    }

    this.resultsTarget.innerHTML = regions.map((r) => {
      const data = JSON.stringify(r).replace(/'/g, "&#39;")
      return `
        <div class="region-autocomplete__item"
             data-action="click->region-autocomplete#select"
             data-region='${data}'>
          <i class="fa-solid fa-map-location-dot me-2 text-muted"></i>
          ${r.name}
        </div>
      `
    }).join("")

    this.resultsTarget.classList.remove("d-none")
  }

  _hideResults() {
    this.resultsTarget.classList.add("d-none")
    this.resultsTarget.innerHTML = ""
  }

  _handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this._hideResults()
    }
  }
}
